import axios from "axios";

import {
  CREATE_USER,
  GET_FILTERED_USERS,
  UPDATE_USER,
} from "actions/ActionTypes";
import { postApi, putApi } from "actions/SendActions";
import { formatHeaders } from "utils/Api";
import rootURL from "utils/RootURL";

export const updateUser = (uuid, data, token, projectSlug, t, callback) =>
  putApi({
    endpoint: `/api/user/v3/admin/users/standard/${uuid}`,
    type: UPDATE_USER,
    item: "users",
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    token,
    data,
    callback,
    message: t("editor-notif:saveSuccess"),
    error: t("editor-notif:saveError"),
  });

export const apiUsersImport = (data, token, projectSlug, error, callback) =>
  postApi({
    endpoint: `/api/user/v3/admin/users/import`,
    type: CREATE_USER,
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    data,
    token,
    callbackError: error,
    callback,
  });

export const onCreate = (data, projectSlug, token, callback, t) =>
  postApi({
    endpoint: "/api/user/v3/admin/users/create/standard",
    type: CREATE_USER,
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    token,
    data,
    message: t("editor-notif:createUserSuccess"),
    error: t("editor-notif:createUserError"),
    callback,
  });

export const fetchUsersByDates = (
  startDate,
  endDate,
  projectSlug,
  token,
  callback,
) =>
  postApi({
    endpoint: "/api/user/v3/admin/users/list_users",
    type: GET_FILTERED_USERS,
    item: "filtered_users",
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    data: {
      role: "standard",
      begin_date: startDate,
      end_date: endDate,
    },
    token,
    callback,
  });

export const apiExportUsersByDates = (
  startDateStr,
  endDateStr,
  projectSlug,
  token,
  callback,
  onError,
) => {
  axios({
    url: rootURL("/api/user/v3/admin/users/list_users"),
    method: "POST",
    headers: formatHeaders(token, [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ]),
    data: {
      role: "standard",
      export: "true",
      begin_date: startDateStr,
      end_date: endDateStr,
    },
  })
    .then((json) => {
      callback(json);
    })
    .catch((error) => {
      if (onError) onError(error);
    });
};

export const fetchUsersViewsExport = (
  startDateStr,
  endDateStr,
  token,
  projectSlug,
  callback,
  onError,
  t,
) => {
  axios({
    url: rootURL(
      `/api/editor_stats/v1/admin/kpi/users_view?period_start=${startDateStr}&period_end=${endDateStr}&export`,
    ),
    method: "GET",
    headers: {
      ...formatHeaders(token, [
        {
          key: "xx-ok-project",
          value: projectSlug,
        },
      ]),
    },
  })
    .then((json) => {
      if (callback) callback(json);
    })
    .catch(() => {
      onError(t("error:genericError"));
    });
};
